module.exports = __webpack_public_path__ + "static/media/ic-chanpin.01535f91.svg";